import React from 'react';

const RefundPolicy = () => (
    <div style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto', lineHeight: '1.6', background: "#fff" }}>
        <h1>Refund Policy</h1>
        <p><strong>Effective Date:</strong> [01-04-2025]</p>

        <p>As RIYMS Microfinance is engaged in financial services and loan disbursement, refund scenarios typically do not apply. However, we have established a transparent policy in special cases:</p>

        <h2>1. Refund Eligibility</h2>
        <ul>
            <li>Double payments due to technical errors</li>
            <li>Unauthorized or fraudulent transactions (after verification)</li>
        </ul>

        <h2>2. Non-refundable Services</h2>
        <p>
            Loan application or processing fees are non-refundable once services are initiated or documentation has been processed.
        </p>

        <h2>3. How to Request a Refund</h2>
        <p>To request a refund, contact us at <strong>support@riyms.com</strong> with payment proof, reason, and account details. Refunds will be processed within 7-10 business days if approved.</p>

        <h2>4. Contact</h2>
        <p>If you have any questions, please email us at <strong>support@riyms.com</strong>.</p>
    </div>
);

export default RefundPolicy;
